// DS EDIT 7 — thread relationship helpers (no supabase imports).

/** Order-preserving dedupe; drops null/undefined/blank entries. */
export function dedupeIds(ids: ReadonlyArray<string | null | undefined>): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of ids) {
    const id = typeof raw === "string" ? raw.trim() : "";
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}

/**
 * Canonical topic list from the dual-schema pair: topicIds (jsonb array,
 * element [0] = primary) is authoritative; a legacy topicId not present in the
 * array is appended (never lost). This is the single read-normalization rule —
 * components with inline hasOldTopicId logic should converge on it.
 */
export function canonicalTopicIds(
  topicId: string | null | undefined,
  topicIds: unknown
): string[] {
  const arr = Array.isArray(topicIds)
    ? topicIds.filter((v): v is string => typeof v === "string")
    : [];
  const ids = dedupeIds(arr);
  if (topicId && !ids.includes(topicId)) {
    // Legacy-only rows: the single topicId IS the primary topic
    return ids.length === 0 ? [topicId] : [...ids, topicId];
  }
  return ids;
}

/** Diff two id sets for bi-directional link reconciliation. */
export function diffIds(
  prev: ReadonlyArray<string>,
  next: ReadonlyArray<string>
): { added: string[]; removed: string[] } {
  const prevSet = new Set(prev);
  const nextSet = new Set(next);
  return {
    added: [...nextSet].filter((id) => !prevSet.has(id)),
    removed: [...prevSet].filter((id) => !nextSet.has(id)),
  };
}
